import { User } from "../../models/user";

export const userState: User = {
    name: '',
    email: '',
    password: '',
  }